import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi } from "./apiService";

/**
 * Gets campaign metafields for a store
 * @param {string} storeDomain - Store domain
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Metafields data or null if error
 */
export const getCampaignMetafields = async (storeDomain, notifyError) => {
    try {
        const endpoint = `${url.CUSTOM_BLOCK_METAFIELDS}?store=${encodeURIComponent(storeDomain)}`;
        const { response, results } = await fetchApi(endpoint, 'GET');

        if (response.ok && results?.data) {
            return results.data;
        }
        return null;
    } catch (error) {
        if (notifyError) {
            notifyError("Failed to load campaign metafields");
        }
        return null;
    }
};

/**
 * Updates campaign metafields for a store
 * @param {string} storeDomain - Store domain
 * @param {Object} metafields - Metafields object
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateCampaignMetafields = async (storeDomain, metafields, notifyError) => {
    return await apiCall(
        url.CUSTOM_BLOCK_METAFIELDS,
        'PUT',
        {
            store: storeDomain,
            metafields,
        },
        notifyError,
        "Failed to update campaign metafields"
    );
};

